export const TEST_ID_TOURIST_INITIALS = 'TEST_ID_TOURIST_INITIALS';
